import { DiscountSettings } from "../models/Organization";

const roundCurrency = (value: number): number => Math.round(value * 100) / 100;

export const getSingleBookingDiscountedTotal = (
  totalAmount: number,
  durationInMinutes: number,
  discountSettings?: DiscountSettings | null,
  occurrenceCount: number = 1
): number => {
  const singleBookingDiscount = discountSettings?.singleBookingDiscount;
  if (!singleBookingDiscount?.enabled) {
    return roundCurrency(totalAmount);
  }

  const totalDurationHours = (durationInMinutes / 60) * Math.max(1, occurrenceCount);
  if (totalDurationHours < singleBookingDiscount.minimumBookingHours) {
    return roundCurrency(totalAmount);
  }

  const discountMultiplier = Math.max(0, 1 - singleBookingDiscount.discountPercent / 100);
  return roundCurrency(totalAmount * discountMultiplier);
};

export const getSingleBookingDiscountAmount = (
  totalAmount: number,
  durationInMinutes: number,
  discountSettings?: DiscountSettings | null,
  occurrenceCount: number = 1
): number => {
  const discounted = getSingleBookingDiscountedTotal(
    totalAmount,
    durationInMinutes,
    discountSettings,
    occurrenceCount
  );
  return roundCurrency(Math.max(0, totalAmount - discounted));
};
